import LinkedInTag from "react-linkedin-insight";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

const LinkedinTracker = () => {
  const path = usePathname();
  const partnerId = "1552633";

  LinkedInTag.init(partnerId, "dc");

  useEffect(() => {
    LinkedInTag.track(path);
  }, [path]);

  return <></>;
};

export default LinkedinTracker;
